export default __webpack_public_path__ + "static/media/HealthcareProfessionalInformationGuide.060728e1.pdf";